import PageState from '../../Shared/pageState';
import Stack from '@mui/material/Stack';
import ControlState from '../../Shared/controlState';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import controlDictionary from '../../Controls/controlDictionary';

export default (page: PageState) => {
  return (
    <Card variant="outlined">
      <CardContent sx={{ padding: 5 }}>
        <Stack>
          {page.controls.map((control: ControlState) => {
            const Placeholder = controlDictionary[control.kind].Placeholder;
            return <Placeholder key={control.id} sx={{ margin: '16px 0' }} />;
          })}
        </Stack>
      </CardContent>
    </Card>
  );
};
